import { Routes, Route, Navigate } from "react-router-dom";
import LandingPageScreen from "../screens/LandingPageScreen";
import OtpPageScreen from "../screens/OtpPageScreen";
import PrivacyPolicy from "../components/PrivacyPolicy";
import TermsAndConditions from "../components/TermsAndConditions";
import HomePage from "../pages/HomePage";
import SubscriptionScreen from "../screens/SubscriptionScreen";
import AwarenessScreen from "../screens/AwarenessScreen";
import JZCTerms from "../components/JZCTerms";
import JZCPrivacyPolicy from "../components/JZCPrivacyPolicy";

type Props = {
  jwtToken: string | null;
  isSubscribe: boolean;
  handleLogout: () => void;
  handleUnSubscribe: () => Promise<void>;
  loader: boolean;
  errorMsg: string;
};

const AllRoutes = (props: Props) => {
  return (
    <>
      <Routes>
        <Route
          path="/home"
          element={
            <HomePage
              isSubscribe={props.isSubscribe}
              handleLogout={props.handleLogout}
              handleUnSubscribe={props.handleUnSubscribe}
              loader={props.loader}
              errorMsg={props.errorMsg}
            />
          }
        />
        <Route
          path="/landing"
          element={<LandingPageScreen jwtToken={props.jwtToken} />}
        />
        <Route
          path="/otp"
          element={<OtpPageScreen jwtToken={props.jwtToken} />}
        />
        <Route
          path="/awareness"
          element={<AwarenessScreen jwtToken={props.jwtToken} />}
        />
        <Route
          path="/subscriptionpage"
          element={
            <SubscriptionScreen
              isSubscribe={props.isSubscribe}
              handleLogout={props.handleLogout}
              handleUnSubscribe={props.handleUnSubscribe}
              loader={props.loader}
              jwtToken={props.jwtToken}
              errorMsg={props.errorMsg}
            />
          }
        />
        {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} /> */}
        {/* <Route path="/terms" element={<TermsAndConditions />} /> */}
        <Route path="/terms" element={<JZCTerms />} />
        <Route path="/privacy-policy" element={<JZCPrivacyPolicy />} />
        <Route path="*" element={<Navigate replace to={"/home"} />} />
      </Routes>
    </>
  );
};

export default AllRoutes;
